export default "__VITE_ASSET__BLC5NC28__"